import BsiIcon, { buttonIcon } from './BsiIcon';
import { MobileTitle } from './Shared';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { AuthRequired, PageHeading, OrderCards, Pagination, ErrorBox } from './Shared';
import { api, t, text, record, statuses, canManage, errorText } from '../helpers';
export class OrdersPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--bsi';
    this.admin = !!this.attrs.admin;
    this.page = 1;
    this.perPage = 20;
    this.total = 0;
    this.orders = [];
    this.status = '';
    this.query = '';
    this.searchValue = '';
    app.setTitle(text(this.admin ? 'admin.title' : 'nav.orders'));
    if (app.session.user && (!this.admin || canManage())) this.load();
  }
  load(page) {
    if (page === void 0) {
      page = this.page;
    }
    this.loading = true;
    this.error = null;
    this.page = page;
    return api('/orders', {
      params: {
        scope: this.admin ? 'all' : 'mine',
        status: this.status || undefined,
        q: this.query || undefined,
        page
      }
    }).then(response => {
      this.orders = response.data.map(record);
      this.total = response.meta?.total || 0;
      this.perPage = response.meta?.perPage || 20;
    }).catch(error => {
      this.error = errorText(error);
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("div", {
      className: "container"
    }, !app.session.user ? m(AuthRequired, null) : this.admin && !canManage() ? m(ErrorBox, {
      error: t('errors.forbidden')
    }) : m("div", null, m(PageHeading, {
      icon: this.admin ? 'list-checks' : 'folders',
      title: t(this.admin ? 'admin.title' : 'nav.orders'),
      description: t(this.admin ? 'admin.description' : 'orders.description')
    }, m(LinkButton, {
      className: "Button Button--primary",
      icon: buttonIcon('plus-circle'),
      href: app.route('bsi.new')
    }, t('nav.new_order'))), this.filters(), m(ErrorBox, {
      error: this.error
    }), this.loading ? m(LoadingIndicator, {
      display: "block"
    }) : m(OrderCards, {
      orders: this.orders,
      admin: this.admin
    }), m(Pagination, {
      page: this.page,
      total: this.total,
      perPage: this.perPage,
      loading: this.loading,
      change: page => this.load(page)
    }))));
  }
  filters() {
    return m("form", {
      className: "BsiFilters",
      onsubmit: e => {
        e.preventDefault();
        this.query = this.searchValue.trim();
        this.load(1);
      }
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: "bsi-status"
    }, t('orders.filter_status')), m("select", {
      id: "bsi-status",
      className: "FormControl",
      value: this.status,
      onchange: e => {
        this.status = e.target.value;
        this.load(1);
      }
    }, m("option", {
      value: ""
    }, t('orders.all_statuses')), statuses.map(status => m("option", {
      value: status
    }, t('status.' + status))))), this.admin && m("div", {
      className: "Form-group BsiSearch"
    }, m("label", {
      htmlFor: "bsi-search"
    }, t('orders.search')), m("div", {
      className: "BsiSearch-control"
    }, m("input", {
      id: "bsi-search",
      type: "search",
      className: "FormControl",
      placeholder: text('orders.search_placeholder'),
      value: this.searchValue,
      oninput: e => this.searchValue = e.target.value
    }), m(Button, {
      className: "Button",
      type: "submit",
      icon: buttonIcon('magnifying-glass'),
      "aria-label": text('orders.search'),
      loading: this.loading
    }, t('orders.search')))), m(Button, {
      className: "Button Button--link BsiRefresh",
      icon: buttonIcon('arrows-clockwise'),
      loading: this.loading,
      onclick: () => this.load()
    }, t('common.refresh')));
  }
}
export class DashboardPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--bsi';
    this.orders = [];
    this.active = 0;
    this.total = 0;
    app.setTitle(text('nav.dashboard'));
    if (app.session.user) this.load();
  }
  load() {
    this.loading = true;
    this.error = null;
    return api('/orders', {
      params: {
        scope: 'mine',
        page: 1
      }
    }).then(response => {
      this.orders = response.data.map(record).slice(0, 5);
      this.active = response.meta?.activeCount || 0;
      this.total = response.meta?.total || 0;
    }).catch(error => {
      this.error = errorText(error);
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("div", {
      className: "container"
    }, !app.session.user ? m(AuthRequired, null) : m("div", null, m(PageHeading, {
      icon: "house",
      title: t('dashboard.greeting', {
        name: app.session.user.displayName()
      }),
      description: t('dashboard.description')
    }, m(LinkButton, {
      className: "Button Button--primary",
      icon: buttonIcon('plus-circle'),
      href: app.route('bsi.new')
    }, t('nav.new_order'))), m(ErrorBox, {
      error: this.error
    }), this.loading ? m(LoadingIndicator, {
      display: "block"
    }) : m("div", null, m("div", {
      className: "BsiSummary"
    }, m("div", null, m("span", {
      className: "BsiSummary-icon"
    }, m(BsiIcon, {
      name: "cpu"
    })), m("div", null, m("strong", null, this.active), m("span", null, t('dashboard.active_orders')))), m("div", null, m("span", {
      className: "BsiSummary-icon"
    }, m(BsiIcon, {
      name: "folders"
    })), m("div", null, m("strong", null, this.total), m("span", null, t('dashboard.total_orders'))))), m("div", {
      className: "BsiSectionHeading"
    }, m("h2", null, t('dashboard.recent_orders')), m(LinkButton, {
      className: "Button Button--link",
      href: app.route('bsi.orders')
    }, t('dashboard.all_orders'))), m(OrderCards, {
      orders: this.orders
    })))));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/OrdersPage', { OrdersPage: OrdersPage,DashboardPage: DashboardPage, });